/**
 * The single allow-list behind both sanitizers of publisher HTML blocks:
 * DOMPurify in the browser (`HtmlItem`) and sanitize-html on the server
 * (`sanitizeHtml.server`). The two must agree, so neither owns a list of its own.
 *
 * - Strips all JavaScript (script tags, event handlers)
 * - Allows inline styles via the style attribute
 * - Blocks style tags and iframes (removed by the backend as well)
 * - Blocks external stylesheets (link tags)
 */
export const HTML_ALLOWED_TAGS = [
  'div', 'span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'a', 'img', 'ul', 'ol', 'li', 'br', 'hr', 'strong', 'em',
  'b', 'i', 'u', 'blockquote', 'pre', 'code', 'table', 'thead',
  'tbody', 'tr', 'th', 'td', 'video', 'audio', 'source',
  'section', 'article', 'header', 'footer', 'nav', 'aside',
  'figure', 'figcaption', 'main', 'button', 'form',
  'input', 'textarea', 'select', 'option', 'label',
];

export const HTML_ALLOWED_ATTRS = [
  'style', 'class', 'id', 'src', 'href', 'alt', 'title',
  'width', 'height', 'target', 'rel', 'type', 'placeholder',
  'value', 'name', 'loading', 'controls', 'autoplay', 'loop', 'muted',
];

export const HTML_FORBIDDEN_TAGS = ['script', 'link', 'style', 'iframe'];

export const HTML_FORBIDDEN_ATTRS = ['onerror', 'onload', 'onclick', 'onmouseover'];

/**
 * The URL schemes DOMPurify accepts by default (`ALLOWED_URI_REGEXP`), so the
 * server accepts exactly the same links.
 */
export const HTML_ALLOWED_URL_SCHEMES = ['http', 'https', 'ftp', 'mailto', 'tel', 'callto', 'sms', 'cid', 'xmpp'];

/** The allowed tags DOMPurify additionally lets carry `data:` URIs (its `DATA_URI_TAGS`). */
export const HTML_DATA_URI_TAGS = ['img', 'video', 'audio', 'source'];
